import axios from 'axios';
import { FieldQueries } from '../graphql/field.queries';
import { FieldMutations } from '../graphql/field.mutations';
import { IFieldDTO } from '../types/field-dto';
import { apolloClient } from '@/apollo';
import { FieldDTOHelper } from '@/api/fields/helpers/field-dto.helper';
import { IField } from '@/dealroom/fields/types/field';
import { EFetchPolicy } from '@/api/types/enums/fetch-policy';

export class FieldService {
  static async load(documentId: string): Promise<IField[]> {
    const {
      data: {
        document: { pages },
      },
    } = await apolloClient.query({
      query: FieldQueries.load,
      variables: { documentId },
      fetchPolicy: EFetchPolicy.NetworkOnly,
    });
    const flattenedFields: IFieldDTO[] = pages.flatMap(page => page.fields);
    return FieldDTOHelper.convertDTOsToFields(flattenedFields);
  }

  static async create(field: IField): Promise<string> {
    const fieldTransferObject: IFieldDTO = FieldDTOHelper.convertFieldsToDTOs([field])[0];
    const response = await apolloClient.mutate({
      mutation: FieldMutations.create,
      variables: { ...fieldTransferObject },
    });
    return response.data.createDocumentField.id;
  }

  static async updateMultiple(fields: IField[]): Promise<void> {
    const fieldUpdateTransferObject: IFieldDTO[] = FieldDTOHelper.convertFieldsToDTOs(fields);
    await apolloClient.mutate({
      mutation: FieldMutations.updateMultiple,
      variables: { fields: fieldUpdateTransferObject },
    });
  }

  static async deleteMultiple(fieldIds: string[]): Promise<boolean> {
    const { data } = await apolloClient.mutate({
      mutation: FieldMutations.deleteMultiple,
      variables: { ids: fieldIds },
    });
    return !!data;
  }

  static async createMultiple(fields: IField[]): Promise<IField[]> {
    const fieldTransferObject: IFieldDTO[] = FieldDTOHelper.convertFieldsToDTOs(fields);
    const response = await apolloClient.mutate({
      mutation: FieldMutations.createMultiple,
      variables: { fields: fieldTransferObject },
    });
    return FieldDTOHelper.convertDTOsToFields(response.data.createDocumentFields);
  }

  static async loadUserSignature(userId: string): Promise<string> {
    const {
      data: { svg_signature },
    } = await axios.get(`/get/settings/signature/${userId}`);
    return svg_signature;
  }
}
